module.exports = __webpack_public_path__ + "img/103.894db5d8.png";